export default __webpack_public_path__ + "images/27c48d52157a6da3cc4723f13d21314b.png";